import { Typography } from 'antd';
import classNames from 'classnames';
import { map } from 'lodash-es';
import { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import SectionHeader from '../SectionHeader';
import Badge from './Badge';
import DateTimeDisplay from '../DateTimeDisplay';
import { DateFormatMedium } from '../../../../utils/dateFormatting';
import { TwoLinesSeparator } from '../../../../components/layout/layoutElements';
import AddressDisplay from './AddressDisplay';
import WaypointLine from './WaypointLine';
import { NoValue } from './NoValue';
import EstimatedTimeTooltip from './EstimatedTimeTooltip';
import { useFlightInformationSectionStyles } from './FlightInformationSection.styles';

export default function FlightInformationSection({
  sectionTitle,
  dateTime,
  highlightedText,
  address,
  badgeLabel,
  distance,
  noDistance,
  flightRows,
  tooltipText,
}) {
  const { styles } = useFlightInformationSectionStyles();
  const titleCss = classNames(styles.badgeDateSectionTitle, {
    [styles.transparentTitle]: !!tooltipText,
  });
  const dateTimeContent = (
    <Typography.Title level={4} className={titleCss}>
      <DateTimeDisplay
        dateTime={dateTime}
        timeClass="text-highlight"
        formatComponent={DateFormatMedium}
      />
    </Typography.Title>
  );

  return (
    <div className={styles.flightInfoSection}>
      <SectionHeader title={sectionTitle} />
      {dateTime && (
        <div className={styles.badgeDateSection}>
          <Badge label={badgeLabel} />
          {tooltipText ? (
            <EstimatedTimeTooltip titleId={tooltipText}>
              {dateTimeContent}
            </EstimatedTimeTooltip>
          ) : (
            dateTimeContent
          )}
        </div>
      )}
      <TwoLinesSeparator />
      <p className={classNames('text-highlight', styles.flightSectionHeader)}>
        {highlightedText}
      </p>
      {address && (
        <>
          <TwoLinesSeparator />
          <AddressDisplay address={address} />
        </>
      )}
      {map(flightRows, ({ label, value }) => (
        <div key={label}>
          <TwoLinesSeparator />
          <div>
            <FormattedMessage id={label} />:{' '}
            {value ? (
              <DateTimeDisplay
                dateTime={value}
                formatComponent={DateFormatMedium}
              />
            ) : (
              <NoValue />
            )}
          </div>
        </div>
      ))}
      <TwoLinesSeparator />
      {!noDistance && <WaypointLine distance={distance} />}
    </div>
  );
}
